import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'

import SentToTWC from '@/components/senttotwc/SentToTWC'

import Orders from '@/components/orders/Orders'
import Order from '@/components/orders/Order'

import Items from '@/components/items/Items'
import NewItem from '@/components/items/NewItem'
import EditItem from '@/components/items/EditItem'

import FreeSamples from '@/components/freeSamples/FreeSamples'
import FreeSampleOrder from '@/components/freeSamples/FreeSampleOrder'
import FreeSamplesNew from '@/components/freeSamples/FreeSamplesNew'
import MyQueue from '@/components/freeSamples/MyQueue'

import Customers from '@/components/customers/Customers'
import NewCustomer from '@/components/customers/NewCustomer'
import Customer from '@/components/customers/Customer'

import QuotesOld from '@/components/quotes/QuotesOld'
import QuoteOld from '@/components/quotes/QuoteOld'

import Quotes from '@/components/quotes/Quotes'
import Quote from '@/components/quotes/Quote'

import Archive from '@/components/Archive'

import Dashboard from '@/components/Dashboard'
// import InstallDashboard from '@/components/InstallDashboard'
import InstallDashboardNew from '@/components/InstallDashboardNew'
import AccountDashboard from '@/components/AccountDashboard'
import MotorisationDashboard from '@/components/MotorisationDashboard'
import SamplesDashboard from '@/components/SamplesDashboard'
import MySales from '@/components/MySales'

// Admin
import Prices from '@/components/admin/prices/Prices'
import NewPrice from '@/components/admin/prices/NewPrice'
import EditPrice from '@/components/admin/prices/EditPrice'

import TWCAPI from '@/components/admin/TWCAPI'

import Postcode from '@/components/admin/Postcodes'
import Promocode from '@/components/admin/Promocodes'
import InstallPrice from '@/components/admin/InstallPrices'
import TomaxZone from '@/components/admin/TomaxZones'

import Fabrics from '@/components/admin/fabrics/Fabrics'
import NewFabric from '@/components/admin/fabrics/NewFabric'
import EditFabric from '@/components/admin/fabrics/EditFabric'

import Colours from '@/components/admin/colours/Colours'
import NewColor from '@/components/admin/colours/NewColor'
import EditColor from '@/components/admin/colours/EditColor'

import FabricCategories from '@/components/admin/FabricCategories'

import FreeSamplePacks from '@/components/admin/freeSamplePacks/FreeSamplePacks'

import CustomCurtains from '@/components/admin/CustomCurtains'

import ImportCustomers from '@/components/admin/import/Customers'
import ImportOrders from '@/components/admin/import/Orders'
import ImportItems from '@/components/admin/import/Items'

import Carts from '@/components/carts/Carts'
import UpdatePassword from '@/components/admin/UpdatePassword'
import OrderDetails from '@/components/admin/OrderDetails'
import salesUsers from '@/components/admin/salesUsers'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/updatePassword',
      name: 'Update Password',
      component: UpdatePassword
    },
    {
      path: '/orderDetails',
      name: 'Order Details',
      component: OrderDetails
    },
    {
      path: '/sales-users',
      name: 'Sales User',
      component: salesUsers
    },
    {
      path: '/sentToTWC',
      name: 'SentToTWC',
      component: SentToTWC
    },
    /* Order Routes */
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/orders/new',
      name: 'New Order',
      component: Order
    },
    {
      path: '/order/:id',
      name: 'Order',
      component: Order
    },
    /* Item Routes */
    {
      path: '/items',
      name: 'Items',
      component: Items
    },
    {
      path: '/items/new',
      name: 'NewItem',
      component: NewItem
    },
    {
      path: '/items/:id',
      name: 'EditItem',
      component: EditItem
    },
    /* Free Sample Routes */
    {
      path: '/freeSamples',
      name: 'Free Samples',
      component: FreeSamples
    },
    {
      path: '/freeSamplesNew',
      name: 'Free Samples New',
      component: FreeSamplesNew
    },
    {
      path: '/MyQueue',
      name: 'My Queue',
      component: MyQueue
    },
    {
      path: '/freeSampleOrder/:id',
      name: 'Free Sample Order',
      component: FreeSampleOrder
    },
    /* Price Routes */
    {
      path: '/prices/:fabricCategoryID',
      name: 'Prices',
      component: Prices
    },
    {
      path: '/prices/new',
      name: 'New Price',
      component: NewPrice
    },
    {
      path: '/prices/:id',
      name: 'Edit Price',
      component: EditPrice
    },
    /* Customer Routes */
    {
      path: '/customers',
      name: 'Customers',
      component: Customers
    },
    {
      path: '/customers/new',
      name: 'New Customer',
      component: NewCustomer
    },
    {
      path: '/customers/:id',
      name: 'Customer',
      component: Customer
    },
    /* Quote Routes */
    {
      path: '/quotesOld',
      name: 'QuotesOld',
      component: QuotesOld
    },
    {
      path: '/quotesOld/new',
      name: 'New Quote Old',
      component: QuoteOld
    },
    {
      path: '/quotesOld/edit/:id',
      name: 'Edit Quote Old',
      component: QuoteOld
    },
    /* Quote Routes New */
    {
      path: '/quotes',
      name: 'Quotes',
      component: Quotes
    },
    {
      path: '/quotes/new',
      name: 'New Quote',
      component: Quote
    },
    {
      path: '/quotes/edit/:id',
      name: 'Edit Quote',
      component: Quote
    },
    /* Archive Routes */
    {
      path: '/archive',
      name: 'Archive',
      component: Archive
    },
    /* TWC Routes */
    {
      path: '/twc/:id',
      name: 'TWC API',
      component: TWCAPI
    },
    {
      path: '/postcodes',
      name: 'Postcodes',
      component: Postcode
    },
    {
      path: '/promocodes',
      name: 'Promocodes',
      component: Promocode
    },
    {
      path: '/installprices',
      name: 'InstallPrices',
      component: InstallPrice
    },
    {
      path: '/tomaxzones',
      name: 'TomaxZones',
      component: TomaxZone
    },
    /** Fabric Routes */
    {
      path: '/fabrics',
      name: 'Fabrics',
      component: Fabrics
    },
    {
      path: '/fabric/new',
      name: 'New Fabric',
      component: NewFabric
    },
    {
      path: '/fabric/:fabricID',
      name: 'Edit Fabric',
      component: EditFabric
    },
    /** Colour Routes */
    {
      path: '/colours/:fabricID',
      name: 'Colours',
      component: Colours
    },
    {
      path: '/newColor',
      name: 'New Color',
      component: NewColor
    },
    {
      path: '/editColor/:colorID',
      name: 'Edit Color',
      component: EditColor
    },
    /** Free Sample Pack Routes */
    {
      path: '/freeSamplePacks',
      name: 'Free Sample Packs',
      component: FreeSamplePacks
    },
    /** Fabric Category Routes */
    {
      path: '/fabricCategories',
      name: 'Fabric Categories',
      component: FabricCategories
    },
    {
      path: '/customCurtains',
      name: 'Custom Curtains',
      component: CustomCurtains
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/sales',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/my-sales',
      name: 'MySales',
      component: MySales
    },
    // {
    //   path: '/dashboard/installation',
    //   name: 'InstallDashboard',
    //   component: InstallDashboard
    // },
    {
      path: '/dashboard/installation',
      name: 'Install Dashboard',
      component: InstallDashboardNew
    },
    {
      path: '/dashboard/account',
      name: 'AccountDashboard',
      component: AccountDashboard
    },
    {
      path: '/dashboard/motorisation',
      name: 'Motorisation Dashboard',
      component: MotorisationDashboard
    },
    {
      path: '/dashboard/samples',
      name: 'Samples Dashboard',
      component: SamplesDashboard
    },
    {
      path: '/import/customers',
      name: 'Import Customers',
      component: ImportCustomers
    },
    {
      path: '/import/orders',
      name: 'Import Orders',
      component: ImportOrders
    },
    {
      path: '/import/items',
      name: 'Import Items',
      component: ImportItems
    },
    {
      path: '/carts',
      name: 'Carts',
      component: Carts
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath !== '/') {
    if (!localStorage.getItem('id_token')) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (localStorage.getItem('id_token')) {
      next({
        path: '/dashboard/sales'
      })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js